import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--regularizations--takers--dashboard`
  }

  doTakersDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--regularizations--takers--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--regularizations--takers--save operations--products--clinics--regularizations--takers--show"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--show--submenu`).dashboardToggleBtn(`TOMADORES`)

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--index`).permission = `medclinic_regularization_takers`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).permission = `medclinic_regularization_takers`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).info_permission = `medclinic_regularization_taker_infos`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).contact_permission = `medclinic_regularization_taker_contacts`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).profile_permission = `medclinic_regularization_taker_profiles`
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--save`).permission = `medclinic_regularization_takers`

      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--regularizations--takers--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
